<template>
  <div class="content">
    <s-location mypage title="1:1 질의응답"/>

        <div class="right mb10">
            <i-input-sel v-model="list.ktype" itemsp="all / 전체 | titl  / 제목 | cont / 내용" class="hide"/>
            <input type="text" v-model="list.kword" @keyup.enter="doSearch"
              class="sch_input " title="검색" placeholder="검색(제목, 내용)"
              />
            <a @click.prevent="doSearch" class="btn icon search_black2 ">검색</a>
        </div>

				<!-- 테이블 -->
				<table class="tbl01 board_list">
					<thead>
					  <tr>
					    <th class="no" >NO</th>
					    <th>제목</th>
					    <th class="day pc w20p">등록일</th>
              <th class="day pc w20p">답변여부</th>
					  </tr>
					</thead>
						<tr v-for="(item,idx) in list.list" :key=idx>
							<td class="al_c">{{ idx+1 }}</td>
							<td class="al_l" @click="getDetail(item)" style="cursor: pointer">
                <span v-html="item.TITL" />
                <span class="txt_new blink" v-if="item.ANSWYN == 'Y'"> new</span>

                <p class="m_date">{{ item.ANSWYN == 'Y' ? '답변완료' : '미답변' }} | {{ item.INCMGDT | moment("YYYY.MM.DD") }} </p>
              </td>
							<td class="pc al_c">{{ item.INCMGDT | moment("YYYY.MM.DD") }}</td>
              <td class="pc al_c">{{ item.ANSWYN == 'Y' ? '답변완료' : '미답변' }}</td>
						</tr>
				</table>
				<!-- //테이블 -->
		    <!-- paging -->
				<div class="paging">
					<p class="num">
            <s-page :pageNo.sync="list.pageNo" :totalCount="list.listTotCnt" :listSize="list.listSize" @changePage="getData"/>
					</p>
				</div>
				<!-- /paging -->
        <div class="btn_group">
          <router-link to="qna_form" class="btn right" style="color:#000000; font:bold; font-size: 18px;">글쓰기</router-link>
        </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list   : {},
    }
  },

  created() {
    this.getData();
  },

  methods: {
    doSearch() {
      this.list.pageNo = 1
      this.getData()
    },
    getDetail(item) {
      this.$router.push({path: '/mypage/qna_view', query: { seq: item.SEQ }})
    },

    getData() {
      this.$ui.httpGet(
        "/mypage/qna_list",
        T.copyWithout(this.list, 'list'),
        ret => this.list = ret.data,
      )
    },

  },
}
</script>